import React, { useState } from "react"
import { connect } from "react-redux"
import "./select-plan-page.scss"

import PlanList from "../../components/choose-plan/plan-list"
import {
  getPlanData,
  getPlanStyle,
  getMaximumNumberOfPlansToDisplay,
  getDefaultPlan,
  getPlanOptionWithName,
  getHasHiddenPlans
} from "../../redux/selectors/plan-selectors"

import {
  selectPlan,
  addEntertainment,
  setAllPlansButtonClicked
} from "../../redux/actions/basket-actions"
import { PropTypes } from "prop-types"
import {
  prevPage,
  nextPage,
  jumpPage
} from "./../../redux/actions/journey-actions"

const SelectPlanPage = ({
  plans,
  planStyle,
  maximumToShow,
  defaultPlan,
  excludeVAT,
  entertainment,
  pageToShowEntertainment,
  getPlanOptionWithName,
  gotoNextPage,
  gotoPrevPage,
  storeName,
  hasHiddenPlans,
  setShowAllPlanButton,
  selectPlan,
  addEntertainment: _addEntertainment
}) => {
  const handleSelectPlan = (selectedID, jumpPage) => {
    selectPlan(selectedID)
    if (jumpPage) {
      jumpPage()
    } else {
      gotoNextPage()
    }
  }

  const [showAllOptions, setShowAllOptions] = useState(false)

  // HACK - Filter the plans to show
  const plansToShow = showAllOptions
    ? plans
    : plans.filter(plan => {
        return plan.data.defaultHidden !== true
      })

  // Function to handle clicking of show all plans button
  function onShowAllPlansButtonClick() {
    setShowAllOptions(true)
    setShowAllPlanButton()
  }

  return (
    <>
      {hasHiddenPlans && !showAllOptions && (
        <div>
          <h1 className="has-hidden-plan-header">
            Here are our recommended plans
          </h1>
          <div className="back-button-container">
            <button
              className="back-button"
              onClick={() => {
                onShowAllPlansButtonClick()
              }}
            >
              Not happy with any of these options? Click here to see all our
              available tariffs
            </button>
          </div>
        </div>
      )}
      <PlanList
        plans={plansToShow}
        planStyle={planStyle}
        defaultPlanID={defaultPlan}
        onSelectPlan={(selectedID, jumpPage) =>
          handleSelectPlan(selectedID, jumpPage)
        }
        maximumToShow={maximumToShow}
        excludeVAT={excludeVAT}
        entertainment={entertainment}
        pageToShowEntertainment={pageToShowEntertainment}
        onAddEntertainment={(entertainmentCost, planID) => {
          _addEntertainment(entertainmentCost, planID)
        }}
        getPlanOptionWithName={getPlanOptionWithName}
        storeName={storeName}
      />
      {hasHiddenPlans && !showAllOptions && (
        <div className="back-button-container">
          <button
            className="back-button"
            onClick={() => {
              onShowAllPlansButtonClick()
            }}
          >
            Not happy with any of these options? Click here to see all our
            available tariffs
          </button>
        </div>
      )}
      <div className="back-button-container">
        <button className="back-button" onClick={gotoPrevPage}>
          Back
        </button>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  plans: getPlanData(state),
  planStyle: getPlanStyle(state),
  maximumToShow: getMaximumNumberOfPlansToDisplay(state),
  defaultPlan: getDefaultPlan(state),
  excludeVAT: state.plans.options.excludeVAT,
  entertainment: state.basket.entertainment,
  pageToShowEntertainment: state.plans.options.pageToShowEntertainment,
  getPlanOptionWithName: getPlanOptionWithName(state),
  storeName: state.condition.storeName,
  hasHiddenPlans: getHasHiddenPlans(state)
})

const mapDispatchToProps = dispatch => ({
  selectPlan: planID => dispatch(selectPlan(planID)),
  gotoNextPage: () => dispatch(nextPage()),
  gotoPrevPage: () => dispatch(prevPage()),
  jumpPage: () => dispatch(jumpPage()),
  addEntertainment: (entertainmentCost, planID) =>
    dispatch(addEntertainment(entertainmentCost, planID)),
  setShowAllPlanButton: () => dispatch(setAllPlansButtonClicked(true))
})

SelectPlanPage.propTypes = {
  plans: PropTypes.array.isRequired,
  planStyle: PropTypes.any,
  maximumToShow: PropTypes.string,
  defaultPlan: PropTypes.string,
  excludeVAT: PropTypes.bool,
  entertainment: PropTypes.object,
  pageToShowEntertainment: PropTypes.string,
  storeName: PropTypes.string,
  hasHiddenPlans: PropTypes.bool,
  getPlanOptionWithName: PropTypes.func,
  gotoNextPage: PropTypes.func,
  gotoPrevPage: PropTypes.func,
  setShowAllPlanButton: PropTypes.func,
  selectPlan: PropTypes.func,
  addEntertainment: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectPlanPage)
